module.exports = __webpack_public_path__ + "img/carCard.4ff82960.png";